import { HttpClient } from '@angular/common/http';
import { Inject, inject, Injectable, PLATFORM_ID } from '@angular/core';
import { catchError, retry, take } from 'rxjs';
import { MostSearchedFlightsResponse, SearchCriteria } from './interfaces';
import { Router } from '@angular/router';
import { FlightSearchService } from '../../../shared/services/flight-search/services/flight-search.service';
import { SharedService } from '../../../shared/services/shared.service';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { SeoService } from '../../../shared/services/seo-service.service';

@Injectable({
  providedIn: 'root',
})
export class MostSearchedFlightsService {
  public isLoading = false;
  public isError = false;
  public isEmpty = false;

  private _mostSearchedFlights: MostSearchedFlightsResponse[] = [];
  private http = inject(HttpClient);
  private router = inject(Router);
  private flightSearchService = inject(FlightSearchService);
  private sharedService = inject(SharedService);
  private isBrowser = false;

  constructor(
    @Inject(PLATFORM_ID) private platformId: object,
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  getMostSearchedFlights() {
    this.isLoading = true;

    if(!this.isBrowser) {
      return;
    }

    const mostSearchedFlights = sessionStorage.getItem('mostSearchedFlights');

    if (mostSearchedFlights) {
      this._mostSearchedFlights = JSON.parse(mostSearchedFlights);

      this.isLoading = false;
      this.isEmpty = !this._mostSearchedFlights.length;

      return;
    }

    this.http
      .get<MostSearchedFlightsResponse[]>('https://flightsearch.travasky.com/api/GetCheapestFlights?resCount=5')
      .pipe(
        retry(3),
        take(1),
        catchError((err) => {
          console.error(err);
          throw err;
        }),
      )
      .subscribe({
        next: (res) => {
          if(!this.isBrowser) {
            return;
          }
          sessionStorage.setItem('mostSearchedFlights', JSON.stringify(res));

          this._mostSearchedFlights = res;
          this.isEmpty = !res.length;
          this.isLoading = false;
        },
        error: () => {
          this.isLoading = false;
          this.isError = true;
        },
      });
  }

  goToSearchResults(searchCriteria: SearchCriteria) {
    localStorage.removeItem('form');

    switch (searchCriteria.flightType) {
      case 'Oneway':
        this.flightSearchService.searchFlight.get('flightType')?.setValue('Oneway');
        break;
      case 'Roundtrip':
        this.flightSearchService.searchFlight.get('flightType')?.setValue('RoundTrip');
        break;
      case 'Multicity':
        this.flightSearchService.searchFlight.get('flightType')?.setValue('MultiCity');
        break;
    }

    this.flightSearchService.searchFlight?.get('passengers.adults')?.setValue(searchCriteria.adultNum);
    this.flightSearchService.searchFlight?.get('passengers.child')?.setValue(searchCriteria.childNum);
    this.flightSearchService.searchFlight?.get('passengers.infant')?.setValue(searchCriteria.infantNum);

    let flights: string[] = [];

    searchCriteria.flights.forEach((e) => {
      const departingOnDate = new Date(e.departingOnDate);

      const formattedDate = departingOnDate.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: '2-digit',
      });

      flights.push(e.departingFrom + '-' + e.arrivingTo + '-' + formattedDate);
    });

    const externalLink = [
      'https://flight.travasky.com/flightResult',
      searchCriteria.language,
      searchCriteria.currency,
      searchCriteria.pos,
      searchCriteria.flightType,
      flights.join('_'),
      searchCriteria.searchId,
      'A-' + searchCriteria.adultNum + '-C-' + searchCriteria.childNum + '-I-' + searchCriteria.infantNum,
      searchCriteria.selectedFlightClass,
      searchCriteria.selectDirectFlightsOnly,
      'all'
    ].join('/');

    console.log(externalLink)
    window.location.href = externalLink;
  }

  get mostSearchedFlights() {
    return this._mostSearchedFlights;
  }
}
